// extracted by mini-css-extract-plugin
module.exports = {"no-results-block":"no-results-block_no-results-block__KEiNl","no-results-block--with-margin":"no-results-block_no-results-block--with-margin__mr0Od"};